interface Review {
  rating: number;
  title?: string;
  text: string;
  reviewer: string;
  source: string;
  date?: string;
}

const reviews: Review[] = [
  {
    rating: 5,
    text: 'MUST READ!!! I initially purchased this book for someone I know who\'s currently incarcerated but I couldn\'t help but read it myself after the first few pages. I believe this material should be in prisons all over the world to motivate and give felons hope!!',
    reviewer: 'Janaei',
    source: 'Amazon Reviews — Verified Purchase'
  },
  {
    rating: 5,
    title: 'Breaking the Stigma: A Survival Guide That Matters',
    text: 'The Forgotten Felon Blueprint Survival Guide is more than a book, it\'s a necessary conversation. John Reed sheds light on a population that is often overlooked, misunderstood, and left to navigate systems without a map.\n\nFrom the very beginning, the book captures the emotional and practical realities of reentry. It doesn\'t romanticize the journey, nor does it shy away from the barriers individuals face after incarceration — housing, employment, stigma, and rebuilding identity. Instead, it offers something powerful: truth paired with strategy.\n\nWhat stands out most is the balance between accountability and empowerment. Reed acknowledges the weight of past decisions while firmly pushing readers toward ownership, growth, and forward movement. The "blueprint" approach makes the content feel actionable rather than overwhelming, which is critical for individuals trying to rebuild their lives step by step.\n\nThis guide is not only for those directly impacted by the justice system, it\'s also essential reading for community workers, caregivers, advocates, and organizations supporting reentry. It helps bridge understanding and encourages a more compassionate, structured approach to support.\n\nIf there\'s one takeaway, it\'s this: people are more than their past, and with the right tools, transformation is possible.\n\nA powerful, purposeful, and much-needed resource ~ Marea',
    reviewer: 'marea perry',
    source: 'Amazon Reviews — Verified Purchase · Format: Paperback',
    date: 'March 18, 2026'
  },
  {
    rating: 5,
    title: 'Great Read',
    text: 'A good friend of mine suggested this book and I must say this a very personable informative read. The author gets straight to the point with a tried and true system of helping people to get back into society and have a good life. Must read for anyone who wants to not be stuck in life.',
    reviewer: 'Eprixciate',
    source: 'Amazon Reviews — Verified Purchase · Format: Kindle',
    date: 'March 17, 2026'
  }
];

export default function ReviewHighlights() {
  return (
    <section id="reviews" className="py-16 md:py-32 bg-stone-800">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-20">
          <p className="text-xs uppercase tracking-widest text-amber-400 mb-3 md:mb-4">Reader Testimonials</p>
          <h2 className="text-4xl md:text-5xl font-black text-amber-50 uppercase">
            What Readers Say
          </h2>
          <div className="w-16 h-1 bg-amber-500 mx-auto mt-4 md:mt-6"></div>
        </div>

        <div className="flex flex-col gap-10 md:gap-14">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="max-w-4xl mx-auto w-full border border-amber-900/50 p-6 sm:p-10 md:p-16 bg-stone-900/60 hover:border-amber-500/70 transition-all duration-300"
            >
              <div className="flex justify-center mb-6 md:mb-10">
                <i className="ri-double-quotes-l text-amber-500 text-5xl md:text-7xl opacity-60"></i>
              </div>

              <div className="flex items-center justify-center space-x-2 mb-4 md:mb-6">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className={`${
                      i < review.rating ? 'ri-star-fill' : 'ri-star-line'
                    } text-amber-400 text-2xl md:text-3xl`}
                  ></i>
                ))}
              </div>

              {review.title && (
                <p className="text-center text-amber-300 font-bold text-lg md:text-xl mb-2 tracking-wide">
                  "{review.title}"
                </p>
              )}

              {review.date && (
                <p className="text-center text-amber-400/50 text-xs uppercase tracking-widest mb-6 md:mb-8">
                  Reviewed on {review.date}
                </p>
              )}

              <p className="text-base sm:text-lg md:text-xl text-amber-100/80 leading-relaxed text-center italic font-light mb-8 md:mb-12 whitespace-pre-line">
                "{review.text}"
              </p>

              <div className="w-16 h-px bg-amber-500/50 mx-auto mb-6 md:mb-8"></div>

              <div className="text-center">
                <p className="text-base md:text-lg font-bold text-amber-50 uppercase tracking-widest mb-2">
                  — {review.reviewer}
                </p>
                <p className="text-xs md:text-sm text-amber-400/70 uppercase tracking-widest">{review.source}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-14 md:mt-20">
          <p className="text-amber-100/60 text-sm uppercase tracking-widest mb-6">
            Enjoyed the book? Share your experience
          </p>
          <a
            href="https://www.amazon.com/FORGOTTEN-FELON-BLUEPRINT-SURVIVAL-GUIDE/dp/B0GQQ2GD8L/ref=tmm_pap_swatch_0?_encoding=UTF8&dib_tag=se&dib=eyJ2IjoiMSJ9._d0Kf4nuS7rF2RKSN4fuJ-X51YV3uWYhGRIV-YItCiyegUDYyNFX6oP010Hy46t7B0L84GrQjsd1Sh3T0J-Ovx_AIdNhk0yxPQFj2iB95IFdVIrVnPwUk0ctpnErd4rKYtU3KYeidaV5EM02kU4x0r5OahEEdm73rJdwz7WWslsBrJQFIm14ljqmjz3eP3ji5C-0NBbSBLYbjVSQ5IwOwbvWmTPD1b184HpJQH_pgZk.8MkATgHnx5StL6DAsY5FwcBXNOnr4PZeWwWpKpsssbo&qid=1774021587&sr=8-1"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-4 bg-amber-500 hover:bg-amber-400 text-stone-900 font-bold uppercase tracking-widest text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-star-fill text-base"></i>
            Leave a Review on Amazon
            <i className="ri-external-link-line text-base"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
